// AGC: Barrel export for voice field renderers + field registry for wizard step generation

export type { VoiceFieldProps } from './types'

export { FieldMicButton } from './FieldMicButton'
export { TitleField } from './TitleField'
export { CategoryField } from './CategoryField'
export { FieldSelector } from './FieldSelector'
export { PriorityField } from './PriorityField'
export { DateField } from './DateField'
export { AssigneeField } from './AssigneeField'
export { QuantityField } from './QuantityField'
export { BrandField } from './BrandField'
export { MachinerySelector } from './MachinerySelector'
export { InputsSelector } from './InputsSelector'
export { GenericField } from './GenericField'

// AGC: Fixed step ordering for wizard — fields appear in this order when present
// AGC: Covers all entry types: task, expense, revenue, field, vehicle, inventory
export const WIZARD_STEP_ORDER = [
  'title',
  'name',
  'category',
  'field',
  'amount',
  'value',
  'quantity',
  'itemQuantity',
  'itemUnit',
  'tankName',
  'brand',
  'model',
  'year',
  'horimeterHours',
  'width',
  'tankCapacity',
  'cropType',
  'managementStatus',
  'priority',
  'dueDate',
  'assignee',
  'machinery',
  'inputs',
  'description',
] as const

// AGC: System/internal slots that should NOT render as user-visible fields
export const SYSTEM_SLOTS = [
  'intentType', 'intentStrength', 'constraints', 'operation', 'targets',
  '_generatorResults', '_recommendations', 'fieldId', 'assigneeName',
  'dateRaw', 'fieldName', 'assignedTo',
] as const

// AGC: Mandatory fields per entry type — always show a step even if missing from backend
export const MANDATORY_FIELDS: Record<string, string[]> = {
  task: ['title', 'category', 'field'],
  expense: ['title', 'category', 'value'],
  revenue: ['title', 'category', 'value'],
  field: ['name'],
  vehicle: ['name', 'category'],
  inventory: ['title'],
}

// AGC: Slots hidden from expense/revenue — task-only + vehicle-specific fields
export const EXPENSE_HIDDEN_SLOTS = [
  'field', 'assignee', 'dueDate', 'priority', 'machinery', 'inputs', 'description',
  'brand', 'model', 'year', 'horimeterHours', 'width', 'tankCapacity',
] as const
